export enum PaymentMethodStatus {
    used = "used",
    pending = "pending",
    chargeable = "chargeable",
    failed = "failed",
}